export const TEN_SECONDS_IN_MS = 10000;
